// extracted by mini-css-extract-plugin
export default {"textWrapper":"RulesAndPolicyText_textWrapper__-lTAo","text":"RulesAndPolicyText_text__J-wDn","link":"RulesAndPolicyText_link__I6ZTY"};